import { UserInfoResponse } from "@logto/browser";
import { InferValueTypes } from "../service-types";
import * as actions from "./actions";

export enum UserAction {
  GET_CONTRACT_RECORDS = "GET_CONTRACT_RECORDS",
  SET_CONTRACT_RECORDS = "SET_CONTRACT_RECORDS",
  GET_PENDING_CONTRACT_RECORDS = "GET_PENDING_CONTRACT_RECORDS",
  SET_PENDING_CONTRACT_RECORDS = "SET_PENDING_CONTRACT_RECORDS",
  GET_CLAIMS = "GET_CLAIMS",
  GET_SKUsOPTIONS = "GET_SKUsOPTIONS",
  SET_SKUsOPTIONS = "SET_SKUsOPTIONS",
  SET_CLAIMS = "SET_CLAIMS",
  SUBMIT_TICKET = "SUBMIT_TICKET",
  SET_USER_DATA = "SET_USER_DATA",
  CLEAN_UP = "USER_STATE_CLEAN_UP",
}

export enum ContractStatus {
  Active = "Active",
  Cancelled = "Cancelled",
  Expired = "Expired",
  CancelRequestDealerReview = "Cancel Request Dealer Review",
  CancelRequestConsumerReview = "Cancel Request Consumer Review",
}
export enum PendingContractStatus {
  Pending = "Pending",
  Processing = "Processing",
  Processed = "Processed",
  Issue = "Issue",
}

export interface Contract {
  id: string;
  contractNumber: string;
  deliveryDate: Date | null;
  purchaseDate: Date | null;
  expirationDate: Date | null;
  customerName: string;
  customerAddress: string;
  status: ContractStatus;
  invoice: string;
  dealer_alias?: string;
}

export interface PendingContract {
  id: string;
  contractNumber: string;
  purchaseDate: Date | null;
  customerName: string;
  customerAddress: string;
  storeName: string;
  salesPerson: string;
  invoice: string;
  status: PendingContractStatus;
  recordType: string;
}

export enum ClaimStatus {
  Draft = "Draft",
  DraftReminder = "Draft Reminder",
  Adjudication = "Adjudication",
  CustomerAction = "Customer Action",
  CARResponse = "CAR Response",
  Approved = "Approved",
  Disposition = "Disposition",
  NonMonetary = "Non-Monetary",
  StoreReferral = "Store Referral",
  SoftClose = "Soft Close",
  Closed = "Closed",
  Denied = "Denied",
  ClaimedDeniedCustomerComm = "Claimed Denied Customer Comm",
  Abandoned = "Abandoned",
}

export interface Claim {
  id: string;
  claimNumber: string;
  warrantyNumber: string;
  customerName: string;
  claimDate: Date;
  customerAddress: string;
  status: ClaimStatus;
  denied?: boolean;
}

interface CRMInfo {
  per_page: number;
  count: number;
  sort_by: string;
  page: number;
  sort_order: string;
  more_records: boolean;
}
interface DBInfo {
  page: number;
  per_page: number;
  total_records: number;
  total_pages: number;
}
export interface AssociatedDealer {
  id: string;
  alias: string;
}

export interface Organization {
  id: string;
  name: string;
  logo: string;
  can_file_claim: boolean;
  permissions: string[];
  associated_dealers: AssociatedDealer[];
  chatbot_enabled: boolean;
  can_cancel_plan: boolean;
}

export interface UserState extends Partial<UserInfoResponse> {
  email: string;
  userName: string;
  name: string;
  phone_number: string;
  selectedOrg: Organization;
  contracts: {
    data: Contract[];
    info: CRMInfo;
  };
  pendingContracts: {
    data: PendingContract[];
    info: DBInfo;
  };
  claims: {
    data: Claim[];
    info: CRMInfo;
  };
  skus: [];
}

export const UserScope = "user";

export type UserActionTypes = ReturnType<InferValueTypes<typeof actions>>;
